import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'


import '../assets/bootstrap.css'
import '../assets/theme.min.css'
import '../assets/custom.css'

import Header from './Header'
import Footer from './Footer'

import favicon from '../images/favicon.png'

const Layout = ({ children, data, location }) => (
    <div className="main-wrapper">
        <Helmet titleTemplate={`%s - ${data.site.siteMetadata.title}`}>
            <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
            <link href={favicon} rel="shortcut icon" type="image/x-icon" />
            <script src="/theme.min.js"></script>
            <html lang="es" />
        </Helmet>
        <Header location={location} />
        {children()}
        <Footer location={location} />
    </div>
)

Layout.propTypes = {
    children: PropTypes.func,
}

export default Layout

export const query = graphql`
    query SiteTitleQuery {
        site {
            siteMetadata {
                title
            }
        }
    }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js